module.exports = __webpack_public_path__ + "static/media/chia-work-7.e318450a.jpg";